


const baseContractlUrl = "Contract"
  const endpoints = {
    getAllContractType:`${baseContractlUrl}/GetAllContractType`,
   
  
  };
  
  export default endpoints;
  



